import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ViewChild } from '@angular/core';
import { OrderItemResult } from '../../../../../core/services/orders/order.models';
import { DashboardOrderService } from '../order.service';
import { BookingProductResult, BookingProduct } from '../../booking/booking.models';
import { MatSelectChange, MatDatepicker } from '@angular/material';
import { Product } from '../../product/product.model';
import * as moment from 'moment';
import { toUTCSmallDate } from '../../../../../core/services/dates.service';


@Component({
    selector: 'fuse-order-item',
    templateUrl: './order-item.component.html',
    styleUrls: ['./order-item.component.scss']
})
export class OrderItemComponent implements OnInit {

    @Input('item') item: OrderItemResult;
    @Input('editable') editable;
    @Output() deleted = new EventEmitter<string>();
    @Output() changed = new EventEmitter<any>();

    @ViewChild('datePicker') datePicker: MatDatepicker<any>;

    product: BookingProduct;

    constructor(
        readonly orderService: DashboardOrderService,
    ) { }

    ngOnInit() {
        // this.datePicker.selectedChanged.subscribe()
        this.orderService
            .getProduct((this.item.product as Product)._id, this.item.date)
            .then((data: BookingProductResult) => {
                this.product = data.product;
                if (this.item.ticket) {
                    // set discountPrice for each order item
                    const ticket = this.product.tickets.filter(t => t._id === this.item.ticket as string);
                    if (ticket && ticket.length) {
                        this.item.price = ticket[0].amount;
                        this.item.priceDiscount = ticket[0].discountAmount;
                    }
                }
            })
            .catch(e => {
                console.warn(e);
            });
    }

    get canEdit() {
        return this.editable;
    }

    delete(id: string) {
        this.deleted.emit(id);
    }

    change(event: MatSelectChange) {
        // console.log(event.source._elementRef.nativeElement.id);
        if (event.source._elementRef.nativeElement.id === 'tarif') {
            const ticketId = event.value; // this.item.ticket as string;
            const ticket = this.product.tickets.filter(t => t._id === ticketId);
            if (ticket && ticket.length) {
                this.item.title = ticket[0].title;
                this.item.vatRate = ticket[0].vatRate;
                this.item.ticket = ticket[0]._id;
                this.item.price = ticket[0].amount;
                this.item.priceDiscount = ticket[0].discountAmount;
            }
        }
        // this.item.priceDiscount =
        this.changed.emit(event);
    }

    changeDate(event: any) {
        // const date = new Date(event);
        this.item.date = toUTCSmallDate(event);
        this.changed.emit(event);
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/order/order-item/order-item.component.ts